import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataSalesPersonsActions } from "./sales-persons.actions";

// **************************************************************************
// SALES PERSONS REDUCER
// **************************************************************************

const load = on(DataSalesPersonsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        salesPerson: {
            ...state.data.salesPerson,
            salesPersonsLoading: true,
        },
    },
}));

const loadSuccess = on(DataSalesPersonsActions.loadSuccess, (state: ApplicationStore, { salesPersons }) => ({
    ...state,
    data: {
        ...state.data,
        salesPerson: {
            ...state.data.salesPerson,
            salesPersons,
            salesPersonsLoading: false,
        },
    },
}));

const loadFailure = on(DataSalesPersonsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        salesPerson: {
            ...state.data.salesPerson,
            salesPersonsLoading: false,
        },
    },
}));

export const salesPersonsReducer = [load, loadSuccess, loadFailure];
